<template>
  <Indecision/>
</template>

<script>
import Indecision from './components/Indecision'

export default {
  name: 'App',
  components:{
    Indecision,
  }
}
</script>

<style>
html, body {
  background-color: black;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
